<template>
  <div class="col-md-3">
    <form-group-input
      ref="input"
      type="text"
      :label="labelCep"
      :readonly="readonly"
      :value="value"
      :name="name"
      :placeholder="placeholder"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      v-validate="{ required: required, length: 9 }"
      v-mask="'#####-###'"
      masked="true"
      @blur="consultaCep($event)"
    />
  </div>
</template>

<script>
import CepService from "../../../domain/cep/CepService";
import Endereco from "../../../domain/cep/Endereco";

export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-cep",
  template: ``,
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  computed: {
    labelCep() {
      return `${
        this.label
      } <a class="btn-cep" href="http://www.correios.com.br/" title="Consultar meu CEP" target="_blank">
      <i class="fa fa-question-circle"></i>
    </a>`;
    }
  },
  methods: {
    validateCep: function(value) {
      let cleanValue = value.replace(/[^\d]/g, "");
      return cleanValue.length === 8;
    },
    consultaCep: function(cep) {
      if (this.validateCep(cep)) {
        this.cepService = new CepService(this.$http);
        this.cepService.getEndereco(cep).then(endereco => {
          this.$store.dispatch("setEndereco", endereco);
        });
      } else {
        this.$store.dispatch("setEndereco", new Endereco());
      }
    },
    normalize(cep) {
      if (cep) {
        let cepClear = cep.replace(/[^\d]/g, "");

        if (this.validateCep(cep)) {
          cep = cepClear.replace(/(\d{5})(\d{3})/, "$1-$2");
        }
      }

      return cep;
    }
  },
  watch: {
    value(value) {
      this.$emit("input", this.normalize(value));
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/Cep.vue